export default __webpack_public_path__ + "static/media/enghien25.832d0b4b.jpg";